import type React from 'react';

import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

interface Props {
    title: string;
    value: string;
    icon: React.ComponentType<any>;
}

export function PerformanceCard(props: Props) {
    return (
        <Card hasBorder={true} backgroundColor='offWhite' borderRadius={8}>
            <div className='flex flex-dir-col justify-sb gap-4 pad-12'>
                <Stack isHorizontal={true} spacing={4} alignItems='center'>
                    <props.icon size={18} color='grey' wrapWithDiv={false} />
                    <Body as='div' color='light'>
                        {props.title}
                    </Body>
                </Stack>
                <Body as='div' size='xlarge' color='dark' isBold={true}>
                    {props.value}
                </Body>
            </div>
        </Card>
    );
}
